var _path, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLegendary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.5301 18.9085C54.8193 19.5885 54.71 20.3726 54.2457 20.9476L31.5388 49.0713C30.7379 50.0632 29.2259 50.0626 28.4257 49.0701L5.7603 20.9565C5.29296 20.3768 5.18634 19.5855 5.48361 18.9027L9.27236 10.2016C9.59009 9.47187 10.3102 9 11.1061 9H48.9932C49.7953 9 50.5198 9.47916 50.8337 10.2172L54.5301 18.9085Z",
    fill: "url(#paint0_linear_3058_4631)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.8052,
    y: 12,
    width: 3,
    height: 9.38594,
    rx: 1.5,
    transform: "rotate(23.9174 12.8052 12)",
    fill: "white",
    fillOpacity: 0.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3058_4631",
    x1: 5,
    y1: 9,
    x2: 50.7536,
    y2: 55.2049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0236636,
    stopColor: "#71AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A58D1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegendary);
export default __webpack_public_path__ + "static/media/legendary.1d40efdf535ad84f44019b338e82da3a.svg";
export { ForwardRef as ReactComponent };